import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Form, Icon, Input, Button } from "antd";
import { validate } from "validate.js";
import forgotPasswordValidationRules from "./validators";
const { Meta } = Card;


type Props = {
    onSubmit: (email: string) => void;
    isLoading: boolean;
};


export default function ForgotPasswordForm({ onSubmit, isLoading }: Props) {
    const navigate = useNavigate();
    const [formState, setFormState] = useState({
        email: "",
        emailValidationError: ""
    });

    const validateForm = () => {
        return validate(
            {
                email: formState.email
            },
            forgotPasswordValidationRules
        );
    };

    const onFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const validationErrors = validateForm();

        if (!validationErrors) {
            setFormState({ ...formState, emailValidationError: "" });
            onSubmit(formState.email);
        } else {
            setFormState({ ...formState, emailValidationError: validationErrors.email[0] });
        }
    };

    const onInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newState = { ...formState, emailValidationError: "", [event.target.name]: event.target.value };
        setFormState(newState);
    };

    const onInputFocus = () => {
        if (formState.emailValidationError) {
            setFormState({ ...formState, emailValidationError: "" });
        }
    };

    const onInputBlur = () => {
        const validationErrors = validateForm();

        if (!validationErrors) {
            setFormState({ ...formState, emailValidationError: "" });
        } else {
            setFormState({ ...formState, emailValidationError: validationErrors.email[0] });
        }
    };

    return (
        <div className="ForgotPasswordForm">
            <div className="authentication-form-wrapper">
                <div className="auth-logo" />

                <Card className="auth-card" bordered={false}>
                    <div className="card-header">
                        <Meta title="Forgot password" />
                    </div>
                    <Form className="forgot-password-form" onSubmit={onFormSubmit}>
                        <Form.Item
                            validateStatus={formState["emailValidationError"] ? "error" : "validating"}
                            help={formState["emailValidationError"] || ""}>
                            <Input
                                size="large"
                                name="email"
                                prefix={<Icon type="mail" style={{ fontSize: "16px", color: "rgba(66,71,71,.54)" }} />}
                                value={formState.email}
                                onChange={onInputChange}
                                onFocus={onInputFocus}
                                onBlur={onInputBlur}
                                placeholder="Your email address"
                            />
                        </Form.Item>
                        <Form.Item>
                            <Button
                                block
                                type="primary"
                                htmlType="submit"
                                className="forgot-password-form-button"
                                loading={isLoading}>
                                {isLoading ? "Loading" : "Send recovery email"}
                            </Button>
                        </Form.Item>
                    </Form>
                </Card>
                <div className="under-card-info">
                    Found your password?{" "}
                    <span className="fake-link" onClick={() => navigate("/auth/login")}>
                        <strong>Sign in</strong>
                    </span>
                </div>
            </div>
        </div>
    );
}